import { defineStore } from 'pinia';
import { useCmsProxy } from '~dsc/composables/useCmsProxy';
import { useNuxtApp } from '#imports';

export const useUserStore = defineStore('user', {
    state: () => ({
        user: {
            email: '',
            emailConfirmation: '',
            firstname: '',
            lastname: '',
            phone: '',
            telephonePrefix: 'FIN|358',
            telephoneNumber: '',
            marketing: [],
            cards: [],
        },
        loggedIn: false,
    }),
    actions: {
        async loadUser() {
            const { $paths } = useNuxtApp();

            const res = await useCmsProxy($paths.getEndpoint('customer'));

            this.user = {
                firstname: res.firstName,
                lastname: res.lastName,
                email: res.emailToken,
                phone: res.phoneNumber,
                telephonePrefix: this.parsePhone('prefix', res.phoneNumber),
                telephoneNumber: this.parsePhone('number', res.phoneNumber),
            };
            this.loggedIn = true;
        },
        resetUser() {
            this.user = {
                email: '',
                emailConfirmation: '',
                firstname: '',
                lastname: '',
                telephonePrefix: 'FIN|358',
                telephoneNumber: '',
                marketing: [],
            };
            this.loggedIn = false;
        },
        parsePhone(type, number) {
            if (!number) return;
            if (number.slice(0, 4) === '+358') {
                return type === 'prefix' ? 'FIN|358' : number.slice(4);
            } else if (number.slice(0, 3) === '+47') {
                return type === 'prefix' ? 'NO|47' : number.slice(3);
            } else if (number.slice(0, 3) === '+46') {
                return type === 'prefix' ? 'SE|46' : number.slice(3);
            }
        },
        async loadCards() {
            const { $paths } = useNuxtApp();

            this.cards = await useCmsProxy($paths.getEndpoint('cards'));
        },
        async logout() {
            const { $dsc } = useNuxtApp();
            try {
                await $fetch('/api/v1/logout');
                this.resetUser();
            } catch (err) {
                $dsc.msg.error().addNotification('messages.something-went-wrong');
            }
        },
    },
    getters: {
        getFirstName: state => state.user.firstname,
        getUser: state => state.user,
        getLabel: state => state.loggedIn ? state.user.firstname : 'login',
        getLoggedIn: state => state.loggedIn,
    },
});
